export type ApiEnv = "production" | "development";

const STORAGE_KEY = "admin_api_env";

const PRODUCTION_API_BASE_URL =
  process.env.REACT_APP_API_BASE_URL?.trim() || "https://nanum-store.com";
const DEVELOPMENT_API_BASE_URL = process.env.REACT_APP_DEV_API_BASE_URL?.trim() || "";

export const API_ENV_OPTIONS: Array<{
  value: ApiEnv;
  label: string;
  url: string;
}> = [
  { value: "production", label: "운영계", url: PRODUCTION_API_BASE_URL },
  ...(DEVELOPMENT_API_BASE_URL
    ? [{ value: "development" as const, label: "개발계", url: DEVELOPMENT_API_BASE_URL }]
    : []),
];

/** 개발/운영 API 전환 UI 노출 여부 (DEV URL이 빌드에 포함된 경우만) */
export const isApiEnvSwitchEnabled = (): boolean => Boolean(DEVELOPMENT_API_BASE_URL);

export const getApiEnv = (): ApiEnv => {
  if (!isApiEnvSwitchEnabled()) {
    return "production";
  }

  const stored = localStorage.getItem(STORAGE_KEY);
  if (stored === "development" || stored === "production") {
    return stored;
  }

  return "production";
};

export const getApiEnvLabel = (env: ApiEnv = getApiEnv()): string =>
  env === "development" ? "개발계" : "운영계";

export const getApiBaseUrl = (): string => {
  if (getApiEnv() === "development" && DEVELOPMENT_API_BASE_URL) {
    return DEVELOPMENT_API_BASE_URL;
  }
  return PRODUCTION_API_BASE_URL;
};

/**
 * API 환경을 변경한다.
 * 토큰은 환경 간 호환되지 않으므로 제거하고 로그인 페이지로 이동한다.
 */
export const setApiEnv = (env: ApiEnv): void => {
  if (!isApiEnvSwitchEnabled()) {
    return;
  }

  if (env !== "production" && env !== "development") {
    return;
  }

  if (env === getApiEnv()) {
    return;
  }

  localStorage.setItem(STORAGE_KEY, env);
  localStorage.removeItem("admin_access_token");
  window.location.href = "/admin/login";
};
